import {InjectionToken} from '@angular/core';

// Definiert den Injection Token für die API-URL
//export const LOGIN_URL = new InjectionToken<string>('API_URL');

export const APP_TEMPLATE = new InjectionToken<string>('APP_TEMPLATE');
export const APP_DOMAIN = new InjectionToken<string>('APP_DOMAIN');
export const APP_URL = new InjectionToken<string>('APP_URL');
export const API_URL = new InjectionToken<string>('API_URL');
export const LOGIN_URL = new InjectionToken<string>('LOGIN_URL');
export const STRIPE_KEY = new InjectionToken<string>('STRIPE_KEY');
